import { render, staticRenderFns } from "./openingHeader.vue?vue&type=template&id=1b5f7045&scoped=true"
import script from "./openingHeader.vue?vue&type=script&lang=js"
export * from "./openingHeader.vue?vue&type=script&lang=js"
import style0 from "./openingHeader.vue?vue&type=style&index=0&id=1b5f7045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f7045",
  null
  
)

export default component.exports